export const createSorter = (key, isNumeric = false) => {
    return (a, b) => {
        const valA = a[key] ?? (isNumeric ? -1 : '');
        const valB = b[key] ?? (isNumeric ? -1 : '');
        return isNumeric ? valA - valB : valA.localeCompare(valB);
    };
};